import { render, staticRenderFns } from "./ArmazenamentoModal.vue?vue&type=template&id=74bc2ef6&"
import script from "./ArmazenamentoModal.vue?vue&type=script&lang=js&"
export * from "./ArmazenamentoModal.vue?vue&type=script&lang=js&"
import style0 from "./ArmazenamentoModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports